import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { 
  ArrowLeft, 
  ChefHat, 
  ShoppingBag, 
  Store,
  Heart,
  CheckCircle,
  Shield,
  Sparkles,
  Clock,
  MessageCircle,
  Camera,
  Award
} from 'lucide-react';

export default function RuchiBoxPromise() {
  const navigate = useNavigate();

  const tiles = [
    {
      id: 'home-cook',
      title: 'Home-Cook Code of Conduct',
      description: 'Standards that make our home cooks special',
      icon: ChefHat,
      color: 'from-orange-500 to-red-500',
      path: '/promise/home-cook'
    },
    {
      id: 'buyer',
      title: "Buyer's Commitment",
      description: 'Your role in building a great community',
      icon: ShoppingBag,
      color: 'from-blue-500 to-indigo-500',
      path: '/promise/buyer'
    },
    {
      id: 'vendor',
      title: "Vendor's Commitment",
      description: 'Quality standards for our vendors',
      icon: Store,
      color: 'from-green-500 to-teal-500',
      path: '/promise/vendor'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      {/* Header */}
      <header className="glass-header sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Button
              variant="ghost"
              onClick={() => navigate('/')}
              className="pl-0"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
                <Heart className="w-5 h-5 text-primary-foreground" />
              </div>
              <span className="font-heading text-xl font-bold">RuchiBox Promise</span>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
            <Shield className="w-10 h-10 text-primary" />
          </div>
          <h1 className="font-heading text-4xl font-bold text-foreground mb-4">
            The RuchiBox Promise
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Our commitment to quality, trust, and community. Every member of our platform 
            upholds these standards to ensure a delightful experience for all.
          </p>
        </div>

        {/* Tiles */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {tiles.map((tile) => (
            <Card 
              key={tile.id}
              className="overflow-hidden cursor-pointer card-hover group"
              onClick={() => navigate(tile.path)}
              data-testid={`promise-tile-${tile.id}`}
            >
              <div className={`h-32 bg-gradient-to-br ${tile.color} flex items-center justify-center`}>
                <tile.icon className="w-16 h-16 text-white opacity-90 group-hover:scale-110 transition-transform" />
              </div>
              <CardContent className="p-6 text-center">
                <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
                  {tile.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {tile.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
}
